import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

//*MUI
import { Box, Modal, Divider, TextField } from "@mui/material";
import EditIcon from "../../Components/Icons/EditIcon";

//*files
import cssClasses from "./EditUnitInfo.module.css";
import CustomInput from "../../Subcomponents/CustomInput";
import DropDown from "../../Subcomponents/DropDown";
import Button from "../../Subcomponents/Button";
import Close from "../../Components/Icons/Close";

//*Redux
import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";
import {
  getAllInventoryStatusFromTable,
  UpdateLeadIdToInventory,
} from "../../Services/SustenanceService";
import {
  UpdateUnitInfo,
  getCrm2LandownerUnit,
  getJdProjectsByParentId,
  getWingsOfProject,
  hasCurrentAllotmentLetter,
} from "../../Services/Project";
import { UpdateUnitStatus } from "../../Services/Event";
import { insertInventoryLogs } from "../../Services/AllAllotments";
import { useSelector } from "react-redux";
import { successTost } from "../../Services/Toast";
import { getProjectInventory } from "../../Services/Inventory";
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";
import { supabase } from "../../supabaseClient";
import { getHoldTypes } from "../../Services/Bank";

const style = {
  position: "absolute",
  top: "47%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "Fit-Content",
  height: "80%",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
};

function EditUnitInfo({ open, handleClose, unitId, respValue, setUnitId }) {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const { unitNo } = useParams();
  const [Units, setUnits] = useState([]);
  const [StatusList, setStatusList] = useState([]);
  const [customReason, setCustomReason] = useState("");
  const [isCustomHoldReason, setIsCustomHoldReason] = useState(false);
  const [holdTypes, setHoldTypes] = useState([]); 
  const [ProjectDetails, setProjectDetails] = useState({
    UnitStatus: "",
    unitStatusString: "",
    saleableArea: "",
    UnitType: "",
    View: "",
    BSPValue: "",
    GstValue: "",
    SdrValue: "",
    TotalCost: "",
    UnitOwnerShip: "",
    OwnerShipName: "",
    remark: "",
    unitStatusChangeReason: "",
    holdReason: "",
    customReason: "",
  });
  console.log("ProjectDetails-->", ProjectDetails);

  const [ProjectDetailsHelperText, setProjectDetailsHelperText] = useState({
    UnitStatus: "",
    saleableArea: "",
    saleableArea: "",
    holdReason: "",
    unitStatusChangeReason: "",
  });

  // CRM 2.0 · M16-F1: landowner project and wing of the unit (only when its VJ project runs on CRM 2.0)
  const [landowner, setLandowner] = useState({
    isCrm2: false,
    locked: false,
    jdProjects: [],
    wings: [],
    projectId: "",
    wingId: "",
  });
  const [landownerHelperText, setLandownerHelperText] = useState({
    project: "",
    wing: "",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(action.activeMenu("project"));
    getProject();
    loadLandowner();
    console.log("project-Details", ProjectDetails);
  }, []);

  async function loadLandowner() {
    try {
      const unit = await getCrm2LandownerUnit(unitId?.unitId?.unitId);
      if (unit?.projectId?.isCrm2 !== true) return;
      const jdProjects = await getJdProjectsByParentId(unit.projectId.projectId);
      const current = jdProjects.find(
        (p) => unit.jdBuId !== null && String(p.buId) === String(unit.jdBuId),
      );
      const wings = current ? await getWingsOfProject(current.projectId) : [];
      const locked = unit.leadId
        ? await hasCurrentAllotmentLetter(unit.unitId, unit.leadId)
        : false;
      setLandowner({
        isCrm2: true,
        locked,
        jdProjects,
        wings,
        projectId: current?.projectId || "",
        wingId: wings.some((w) => w.wingId === unit.jdWingId)
          ? unit.jdWingId
          : "",
      });
    } catch (err) {
      console.error("loadLandowner", err);
    }
  }

  async function onLandownerProjectChange(projectId) {
    setLandowner((prev) => ({ ...prev, projectId, wingId: "", wings: [] }));
    setLandownerHelperText({ project: "", wing: "" });
    try {
      const wings = await getWingsOfProject(projectId);
      setLandowner((prev) =>
        prev.projectId === projectId ? { ...prev, wings } : prev,
      );
    } catch (err) {
      console.error("getWingsOfProject", err);
    }
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  function getProject() {
    console.log("unit-No", unitId);

    // Check if the "Release" option is accessible for the logged-in user
    const isHoldReleaseAccessible =
      loggedInUser?.roleId?.accessibleTabs?.["Hold/Release"]?.Release
        ?.isAccessible;

    setProjectDetails((pre) => {
      pre.UnitType = unitId?.unitId?.inventoryTypeId?.type;
      pre.UnitStatus = unitId?.unitId?.inventoryStatusId?.inventoryStatusId;
      pre.chargeableArea = unitId?.unitId?.chargeableArea;
      pre.saleableArea = unitId?.unitId?.saleableArea;
      pre.BSPValue = unitId?.unitId?.BSP ? unitId?.unitId?.BSP : 0;
      pre.GstValue = unitId?.unitId?.GST ? unitId?.unitId?.GST : 0;
      pre.SdrValue = unitId?.unitId?.SDR ? unitId?.unitId?.SDR : 0;
      pre.TotalCost =
        (parseFloat(unitId?.unitId?.BSP)
          ? parseFloat(unitId?.unitId?.BSP)
          : 0) +
        (parseFloat(unitId?.unitId?.GST)
          ? parseFloat(unitId?.unitId?.GST)
          : 0) +
        (parseFloat(unitId?.unitId?.SDR) ? parseFloat(unitId?.unitId?.SDR) : 0);
      pre.UnitOwnerShip = unitId?.unitId?.unitOf;
      pre.OwnerShipName = unitId?.unitId?.landOwnerName;
      return { ...pre };
    });

    getAllInventoryStatusFromTable()
      .then((response88) => {
        console.log("getAllInventoryStatusFromTable", response88);
        const filteredStatusList = response88.data;
    setStatusList(filteredStatusList);
      })
      .catch((err) => {
        console.error("getAllInventoryStatusFromTable", err);
      });
  }

  function onSubmit() {
    console.log("Enter on submit btn");
    console.log("ProjectDetails-->", ProjectDetails);

    if (
      ["reserved", "on hold"].includes(
        ProjectDetails?.unitStatusString?.trim().toLowerCase(),
      )
    ) {
      if (!ProjectDetails.unitStatusChangeReason?.trim()) {
        setProjectDetailsHelperText((prev) => ({
          ...prev,
          unitStatusChangeReason: "Reason is required",
        }));
        return;
      }

      if (ProjectDetails.unitStatusChangeReason.trim().length < 5) {
        setProjectDetailsHelperText((prev) => ({
          ...prev,
          unitStatusChangeReason: "Reason must be at least 5 characters long",
        }));
        return;
      }
    }

    let obj = {
      BSP: ProjectDetails?.BSPValue,
      GST: ProjectDetails?.GstValue,
      SDR: ProjectDetails?.SdrValue,
      totalCost: ProjectDetails?.TotalCost,
      unitOf: ProjectDetails?.UnitOwnerShip,
      landOwnerName: ProjectDetails?.OwnerShipName || null,
      remarks: ProjectDetails?.remark || "",
    };

    // CRM 2.0 · M16-F1: the landowner project and wing are saved with the ownership. Once the booking's
    // allotment letter is made, the ownership, name, project and wing stay as they are.
    if (landowner.isCrm2) {
      if (landowner.locked) {
        obj.unitOf = unitId?.unitId?.unitOf;
        obj.landOwnerName = unitId?.unitId?.landOwnerName || null;
      } else if (ProjectDetails?.UnitOwnerShip === "Landowner") {
        if (landowner.jdProjects.length === 0) {
          setLandownerHelperText({
            project:
              "No landowner project is added for this project. Add it in Project Details › JD Projects first.",
            wing: "",
          });
          return;
        }
        if (!landowner.projectId) {
          setLandownerHelperText({ project: "Select the landowner project", wing: "" });
          return;
        }
        if (!landowner.wingId) {
          setLandownerHelperText({ project: "", wing: "Select the landowner wing" });
          return;
        }
        const jdProject = landowner.jdProjects.find(
          (p) => p.projectId === landowner.projectId,
        );
        obj.jdBuId = jdProject?.buId;
        obj.jdWingId = landowner.wingId;
      } else {
        obj.jdBuId = null;
        obj.jdWingId = null;
      }
    }

    UpdateUnitInfo(obj, unitId?.unitId?.unitId)
      .then(() => {
        const originalBSP = parseFloat(unitId?.unitId?.BSP) || 0;
        const originalGST = parseFloat(unitId?.unitId?.GST) || 0;
        const originalSDR = parseFloat(unitId?.unitId?.SDR) || 0;
        const newBSP = parseFloat(ProjectDetails?.BSPValue) || 0;
        const newGST = parseFloat(ProjectDetails?.GstValue) || 0;
        const newSDR = parseFloat(ProjectDetails?.SdrValue) || 0;

        if (
          originalBSP !== newBSP ||
          originalGST !== newGST ||
          originalSDR !== newSDR
        ) {
          insertInventoryLogs({
            userId: loggedInUser?.userId,
            status: "Price Updated",
            projectId: unitId?.unitId?.projectId,
            unitId: unitId?.unitId?.unitId,
            oldUnitDetails: {
              oldUnit: {
                unitId: unitId?.unitId?.unitId,
                bsp: originalBSP,
                gst: originalGST,
                sdr: originalSDR,
                totalCost: originalBSP + originalGST + originalSDR,
              },
            },
            last_updated_at: Date.now(),
            created_at: Date.now(),
          }).catch((err) => {
            console.error("err while inserting price updated inventory log", err);
          });
        }

        UpdateUnitStatus(ProjectDetails?.UnitStatus, unitId?.unitId?.unitId)
          .then(() => {
            let InventoryLogObj = {
              userId: loggedInUser?.userId,
              status: ProjectDetails?.unitStatusString,
              projectId: unitId?.unitId?.projectId,
              unitId: unitId?.unitId?.unitId,
              holdReason: ProjectDetails.holdReason,
              unitStatusChangeReason: ProjectDetails.unitStatusChangeReason,
              last_updated_at: Date.now(),
              created_at: Date.now(),
            };

            insertInventoryLogs(InventoryLogObj)
              .then(async () => {
                // ✅ Same extra logic from UpdateStatus
                if (
                  ProjectDetails.unitStatusString === "Available" &&
                  unitId?.unitId?.leadId?.leadId
                ) {
                  let allotmentRes = await supabase
                    .from("AllotmentPayment")
                    .update({ status: "Released" })
                    .eq("unitId", unitId?.unitId?.unitId)
                    .eq("leadId", unitId?.unitId?.leadId?.leadId)
                    .select();

                  if (allotmentRes.data[0]?.paymentId) {
                    await supabase
                      .from("EventTokenLeadRelations")
                      .update({ status: "active" })
                      .eq("paymentId", allotmentRes.data[0].paymentId);
                  }

                  await supabase
                    .from("LeadStatus")
                    .update({
                      status: allotmentRes.data[0]?.paymentId
                        ? "Checkpoint Two Cleared"
                        : "Site Visit Done",
                    })
                    .eq("leadId", unitId?.unitId?.leadId?.leadId);

                  let leadObj = {
                    leadId: null,
                    last_updated_at: Date.now(),
                  };

                  UpdateLeadIdToInventory(leadObj, unitId?.unitId?.unitId)
                    .then((resp) => {
                      console.log("leadId-set-to-null", resp);
                    })
                    .catch((err) => {
                      console.log("UpdateLeadIdToInventory", err);
                    });
                }

                handleClose();
                getProject();
                respValue(true);
                successTost(
                  `Unit Status of ${unitId?.unitId?.unitNo} Updated Successfully!`,
                );
              })
              .catch((err) => {
                console.log("err while inserting into inventory log", err);
              });
          })
          .catch((err) => {
            console.error("UpdateUnitStatus", err);
          });
      })
      .catch((err) => {
        console.error("UpdateUnitInfo", err);
      });
  }

  const isUnitCurrentlyLocked =
    (unitId?.unitId?.inventoryStatusId?.status || "").trim().toLowerCase() ===
    "reserved";

   useEffect(() => {
  const fetchHoldTypes = async () => {
    try {
      const response = await getHoldTypes();
      console.log("API response:", response);  

      if (response && Array.isArray(response.data)) {
        setHoldTypes(response.data); 
      } else {
        console.error("Expected an array in 'data' key, but received:", response);
      }
    } catch (error) {
      console.error("Error fetching hold types:", error);
    }
  };

  fetchHoldTypes();
}, []);



  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>
                    Unit : {unitId?.unitId?.unitNo}
                  </Box>{" "}
                  <Box mt={0.4}>
                    <EditIcon color={"#000000"} fill={"none"} />
                  </Box>
                </Box>
                <Box className={cssClasses.bhkTitle}>
                  {unitId?.unitId?.inventoryTypeId?.type}
                </Box>
              </Box>
              <Box
                ml={"auto"}
                mt={1}
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              >
                <Close width={"1.2rem"} height={"1.2rem"} />
              </Box>
            </Box>
          </Box>

          <Box width={"100%"} height={"85%"} overflow={"auto"}>
            <Box margin={"1.5rem 3.2rem"}>
              <Box className={cssClasses.SubHeaderTitle}>Edit Info:</Box>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "3rem",
                    alignItems: "flex-start",
                    flexWrap: "wrap", // Allow wrapping for smaller screens
                  }}
                >
                  {/* Unit Type */}
                  <Box className={cssClasses.ThirdDiv}>
                    <Box className={cssClasses.InputTitle} mt={2.5}>
                      Unit Type :
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        inputType="text"
                        value={ProjectDetails?.UnitType}
                        disabled
                      />
                    </Box>
                  </Box>

                  {/* Unit Status */}
                  <Box className={cssClasses.ThirdDiv}>
                    <Box className={cssClasses.InputTitle} mt={2.5}>
                      Unit Status :
                    </Box>
                    <Box
                      className={cssClasses.widthBox}
                      sx={{ position: "relative" }}
                    >
                      <Box
                        sx={{
                          pointerEvents: isUnitCurrentlyLocked
                            ? "none"
                            : "auto",
                        }}
                      >
                        <DropDown
                          placeHolder="Select"
                          list={StatusList.map((el) => ({
                            label: el.status,
                            value: el.inventoryStatusId,
                          }))}
                          selectedValue={ProjectDetails?.UnitStatus}
                          onChangeSelect={(value) => {
                            if (isUnitCurrentlyLocked) return; // ✅ extra safety

                            const status = StatusList.find(
                              (s) => s.inventoryStatusId === value,
                            );

                            setProjectDetails((prev) => ({
                              ...prev,
                              UnitStatus: value,
                              unitStatusString: status?.status,
                            }));
                          }}
                          style={{
                            background: "#F2F4F7",
                            selectedColor: "#667085",
                          }}
                        />
                      </Box>

                      {/* Invisible blocker to prevent clicks */}
                      {isUnitCurrentlyLocked && (
                        <Box
                          sx={{
                            position: "absolute",
                            inset: 0,
                            zIndex: 10,
                            background: "transparent",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      )}
                    </Box>
                  </Box>
                </Box>

                {["reserved", "on hold"].includes(
                  ProjectDetails?.unitStatusString?.trim().toLowerCase(),
                ) && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2rem",
                      alignItems: "flex-start",
                      mt: 2,
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    {/* Hold Reason – ONLY for Locked */}
                    {ProjectDetails?.unitStatusString?.trim().toLowerCase() ===
                      "reserved" && (
                      <Box className={cssClasses.ThirdDiv} sx={{ flex: 1 }}>
                        <Box
                          className={cssClasses.InputTitle}
                          style={{ marginTop: "1rem" }}
                        >
                          Hold Reason:<span style={{ color: "red" }}>*</span>
                        </Box>
                        <Box className={cssClasses.widthBox}>
                          <DropDown
                            placeHolder="Select"
                            // list={[
                            //   {
                            //     label: "Change of Design",
                            //     value: "Change of Design",
                            //   },
                            //   {
                            //     label: "Management Hold",
                            //     value: "Management Hold",
                            //   },
                            //   {
                            //     label: "Leased/Preleased",
                            //     value: "Leased/Preleased",
                            //   },
                            //   { label: "Amenities", value: "Amenities" },
                            //   { label: "Future Sell", value: "Future Sell" },
                            //     {label:"Landowner",value:"Landowner"},
                            //   { label: "Other", value: "Other" },
                            // ]}
                           list={holdTypes.map((holdType) => ({
                           label: holdType.HoldType,
                           value: holdType.HoldType  
                           }))}
                            selectedValue={ProjectDetails?.holdReason}
                            onChangeSelect={(value) => {
                              setProjectDetails((prev) => ({
                                ...prev,
                                holdReason: value,
                                unitStatusChangeReason: "",
                              }));
                            }}
                          />
                        </Box>
                      </Box>
                    )}

                    {/* Note – for BOTH Locked & On Hold */}
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <Box
                        className={cssClasses.InputTitle}
                        style={{ marginTop: "1rem" }}
                      >
                        Note:<span style={{ color: "red" }}>*</span>
                      </Box>

                      <Box sx={{ width: "100%", marginLeft: "3rem" }}>
                        <TextField
                          placeholder={
                            ProjectDetails?.unitStatusString
                              ?.trim()
                              .toLowerCase() === "reserved" &&
                            !ProjectDetails?.holdReason
                              ? "Select Hold Reason first"
                              : "Enter note"
                          }
                          fullWidth
                          size="large"
                          disabled={
                            ProjectDetails?.unitStatusString
                              ?.trim()
                              .toLowerCase() === "reserved" &&
                            !ProjectDetails?.holdReason
                          }
                          value={ProjectDetails?.unitStatusChangeReason || ""}
                          onChange={(e) => {
                            setProjectDetails((prev) => ({
                              ...prev,
                              unitStatusChangeReason: e.target.value,
                            }));
                          }}
                          autoComplete="off"
                          multiline
                          rows={4}
                          inputProps={{ maxLength: 100 }}
                          sx={{
                            "& .MuiInputBase-root": {
                              backgroundColor: "#F9F9F9",
                              borderRadius: "8px",
                              border: "1px solid #E0E0E0",
                            },
                          }}
                          label="Enter note"
                        />
                      </Box>
                    </Box>
                  </Box>
                )}

                <Box mt={3} mb={2}>
                  <Divider />
                </Box>
              </Box>

              <Box className={cssClasses.flexRow} margin={"3rem 0"}>
                <Box>
                  <Box className={cssClasses.InputTitle1}>
                    Saleable Area(Sq.ft) :
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={"Enter saleable area"}
                      value={ProjectDetails?.saleableArea}
                      disabled={true}
                    />
                  </Box>
                </Box>

                <Box>
                  <Box className={cssClasses.InputTitle1}>
                    Chargeable Area(Sq.ft) :
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={"Enter chargeable area"}
                      value={ProjectDetails?.chargeableArea}
                      disabled={true}
                      helperText={ProjectDetailsHelperText?.chargeableArea}
                    />
                  </Box>
                </Box>
              </Box>

              <Box className={cssClasses.flexRow} margin={"3rem 0"}>
                <Box>
                  <Box className={cssClasses.InputTitle1}>
                    Agreement Value :{" "}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={"Enter BSP"}
                      value={ProjectDetails?.BSPValue}
                      inputType={"number"}
                      position={"start"}
                      image={"true"}
                      labelText={RupeeIcon}
                      handleChange={(_value) => {
                        console.log(_value);
                        setProjectDetails((pre) => {
                          pre.BSPValue = _value;
                          return { ...pre };
                        });

                        if (_value !== "") {
                          setProjectDetails((pre) => {
                            pre.TotalCost =
                              parseFloat(_value) +
                              (parseFloat(ProjectDetails?.GstValue)
                                ? parseFloat(ProjectDetails?.GstValue)
                                : 0) +
                              (parseFloat(ProjectDetails?.SdrValue)
                                ? parseFloat(ProjectDetails?.SdrValue)
                                : 0);
                            return { ...pre };
                          });
                        } else {
                          setProjectDetails((pre) => {
                            pre.TotalCost = "";
                            return { ...pre };
                          });
                        }
                      }}
                    />
                  </Box>
                </Box>

                <Box>
                  <Box className={cssClasses.InputTitle1}>GST:</Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={"Enter GST"}
                      value={ProjectDetails?.GstValue}
                      inputType={"number"}
                      position={"start"}
                      image={"true"}
                      labelText={RupeeIcon}
                      handleChange={(_value) => {
                        console.log(_value);
                        setProjectDetails((pre) => {
                          pre.GstValue = _value;
                          return { ...pre };
                        });

                        if (_value !== "") {
                          setProjectDetails((pre) => {
                            pre.TotalCost =
                              (parseFloat(ProjectDetails?.BSPValue)
                                ? parseFloat(ProjectDetails?.BSPValue)
                                : 0) +
                              parseFloat(_value) +
                              (parseFloat(ProjectDetails?.SdrValue)
                                ? parseFloat(ProjectDetails?.SdrValue)
                                : 0);
                            return { ...pre };
                          });
                        } else {
                          setProjectDetails((pre) => {
                            pre.TotalCost = "";
                            return { ...pre };
                          });
                        }
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              <Box className={cssClasses.flexRow} margin={"3rem 0"}>
                <Box>
                  <Box className={cssClasses.InputTitle1}>SDR : </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={"Enter SDR"}
                      inputType={"number"}
                      position={"start"}
                      image={"true"}
                      labelText={RupeeIcon}
                      value={ProjectDetails?.SdrValue}
                      handleChange={(_value) => {
                        console.log(_value);
                        setProjectDetails((pre) => {
                          pre.SdrValue = _value;
                          return { ...pre };
                        });

                        if (_value !== "") {
                          setProjectDetails((pre) => {
                            pre.TotalCost =
                              (parseFloat(ProjectDetails?.BSPValue)
                                ? parseFloat(ProjectDetails?.BSPValue)
                                : 0) +
                              (parseFloat(ProjectDetails?.GstValue)
                                ? parseFloat(ProjectDetails?.GstValue)
                                : 0) +
                              parseFloat(_value);
                            return { ...pre };
                          });
                        } else {
                          setProjectDetails((pre) => {
                            pre.TotalCost = "";
                            return { ...pre };
                          });
                        }
                      }}
                    />
                  </Box>
                </Box>

                <Box>
                  <Box className={cssClasses.InputTitle1}> Total Cost :</Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={"Enter Total Cost"}
                      value={
                        ProjectDetails?.TotalCost
                          ? ProjectDetails?.TotalCost
                          : 0
                      }
                      disabled={true}
                      inputType={"number"}
                      position={"start"}
                      image={"true"}
                      labelText={RupeeIcon}
                    />
                  </Box>
                </Box>
              </Box>
              <Divider />
              <Box className={cssClasses.flexRow} margin={"3rem 0"}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.InputTitle2} mt={2}>
                    Unit Ownership :
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <DropDown
                      placeHolder={"Select"}
                      list={["VJ", "Landowner"]}
                      selectedValue={ProjectDetails?.UnitOwnerShip}
                      disable={landowner.isCrm2 && landowner.locked}
                      onChangeSelect={(value) => {
                        setProjectDetails((pre) => {
                          pre.UnitOwnerShip = value;
                          console.log("value", value);
                          return { ...pre };
                        });
                        setLandownerHelperText({ project: "", wing: "" });
                      }}
                      style={{
                        background: "#F2F4F7",
                        selectedColor: "#667085",
                      }}
                      helperText={ProjectDetailsHelperText.UnitStatus}
                    />
                  </Box>
                </Box>

                {ProjectDetails?.UnitOwnerShip === "Landowner" && (
                  <Box className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle2} mt={2}>
                      Ownership Name:
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        inputType={"text"}
                        placeholder={"Enter LandOwner Name"}
                        value={ProjectDetails?.OwnerShipName}
                        disabled={landowner.isCrm2 && landowner.locked}
                        handleChange={(value) => {
                          setProjectDetails((pre) => {
                            pre.OwnerShipName = value;
                            return { ...pre };
                          });
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>

              {landowner.isCrm2 && ProjectDetails?.UnitOwnerShip === "Landowner" && (
                <Box className={cssClasses.flexRow} margin={"0 0 3rem 0"}>
                  <Box className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle2} mt={2}>
                      Landowner Project :
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <DropDown
                        placeHolder={"Select"}
                        list={landowner.jdProjects.map((p) => ({
                          label: p.projectShortCode
                            ? `${p.projectName} (${p.projectShortCode})`
                            : p.projectName,
                          value: p.projectId,
                        }))}
                        selectedValue={landowner.projectId}
                        disable={landowner.locked}
                        onChangeSelect={onLandownerProjectChange}
                        style={{
                          background: "#F2F4F7",
                          selectedColor: "#667085",
                        }}
                        helperText={landownerHelperText.project}
                      />
                    </Box>
                  </Box>

                  <Box className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle2} mt={2}>
                      Landowner Wing :
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <DropDown
                        placeHolder={"Select"}
                        list={landowner.wings.map((w) => ({
                          label: w.wingName,
                          value: w.wingId,
                        }))}
                        selectedValue={landowner.wingId}
                        disable={landowner.locked || !landowner.projectId}
                        onChangeSelect={(value) => {
                          setLandowner((prev) => ({ ...prev, wingId: value }));
                          setLandownerHelperText({ project: "", wing: "" });
                        }}
                        style={{
                          background: "#F2F4F7",
                          selectedColor: "#667085",
                        }}
                        helperText={landownerHelperText.wing}
                      />
                    </Box>
                  </Box>
                </Box>
              )}

              {landowner.isCrm2 && landowner.locked && (
                <Box className={cssClasses.lockNote}>
                  The allotment letter is already made for this booking. The landowner project and wing can't be changed.
                </Box>
              )}

              {ProjectDetails?.unitStatusString?.trim().toLowerCase() ===
                "on hold" && (
                <Box
                  className={cssClasses.flexRow}
                  sx={{
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "flex-start" },
                    margin: { xs: "3rem 0", sm: "3rem 10px" },
                  }}
                >
                  <Box
                    className={cssClasses.InputTitle}
                    width={{ xs: "100%", sm: "90px" }}
                    mb={{ xs: 0, sm: 3 }}
                  >
                    Reason:<span style={{ color: "red" }}>*</span>
                  </Box>

                  <Box
                    className={cssClasses.widthBox}
                    sx={{
                      marginLeft: { xs: 0, sm: "3rem" },
                      width: { xs: "100%", sm: "270px" },
                    }}
                  >
                    <TextField
                      placeholder="Enter the Reason"
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={ProjectDetails?.Reason}
                      onChange={(e) => {
                        const value = e.target.value;
                        setProjectDetails((prev) => ({
                          ...prev,
                          Reason: value,
                        }));
                        let errorMsg = "";
                        if (!value.trim()) {
                          errorMsg = "Reason is required";
                        } else if (value.trim().length < 5) {
                          errorMsg =
                            "Reason must be at least 5 characters long";
                        }
                        setProjectDetailsHelperText((prev) => ({
                          ...prev,
                          Reason: errorMsg,
                        }));
                      }}
                      helperText={ProjectDetailsHelperText.Reason || ""}
                      error={!!ProjectDetailsHelperText.Reason}
                      FormHelperTextProps={{
                        sx: {
                          fontSize: "1.4rem",
                          marginLeft: 0,
                          marginTop: 0,
                          lineHeight: "1.6rem",
                          height: "1.6rem",
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { border: "1px solid #1a55cdff" },
                          "&.Mui-focused fieldset": {
                            border: "1px solid #b0c6efff",
                          },
                        },
                        "& input": { fontSize: "1.5rem" },
                        "& .MuiFormHelperText-root": {
                          fontSize: "1.3rem",
                          height: "1.6rem",
                        },
                      }}
                    />
                  </Box>
                </Box>
              )}

              {/* <Box className={cssClasses.ThirdDiv} margin={'3rem 0'}>
                <Box className={cssClasses.ThirdDiv}>
                  <Box className={cssClasses.InputTitle2} mt={2}>
                    Date :{' '}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput placeholder={'Enter Date'} />
                  </Box>
                </Box>
                <Box className={cssClasses.ThirdDiv}>
                  <Box className={cssClasses.InputTitle2} mt={2}>
                    Scheme :
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput placeholder={'Enter Scheme'} />
                  </Box>
                </Box>
              </Box> */}

              {(unitId?.unitId?.inventoryStatusId?.status === "Reserved" ||
                unitId?.unitId?.inventoryStatusId?.status === "Locked") && (
                <Box margin={"2rem 0"}>
                  <Box className={cssClasses.InputTitle}>Remark</Box>
                  <CustomInput
                    value={ProjectDetails?.remark}
                    handleChange={(e) => {
                      setProjectDetails((pre) => {
                        pre.remark = e;
                        console.log("remark", e);
                        return { ...pre };
                      });
                    }}
                    inputType={"TextArea"}
                    rows={4}
                    placeholder={"Enter a description..."}
                  />
                </Box>
              )}
            </Box>
          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={"fit-Content"} ml={"auto"}>
                <Button
                  style={{
                    color: "#344054",
                    backgroundColor: "#ffffff",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Discard"}
                  clicked={handleClose}
                />
              </Box>

              <Box width={"fit-Content"}>
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Save"}
                  clicked={() => onSubmit()}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default EditUnitInfo;
